import { Box, Modal } from "@mui/material";
import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const ImagePreviewLoop = ({
  openImage,
  imageSelection,
  setImageSelection,
  setOpenImage,
  setCurrentIndex,
  setCurrentImages,
  currentIndex,
  currentImages,
}) => {
  const [zoom, setZoom] = useState(1);

  const imagestyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    bgcolor: "background.paper",
    border: "none",
    boxShadow: 0,
    p: 2,
    overflowY: "auto",
  };

  const handleZoomIn = () => setZoom((prev) => Math.min(prev + 0.2, 3)); // max 3x
  const handleZoomOut = () => setZoom((prev) => Math.max(prev - 0.2, 0.5)); // min 0.5x

  const getImageUrl = (item) => {
    if (!item) return null;
    if (typeof item === "string") return item;
    return item?.url || item?.fileUrl || item?.path || null;
  };

  //   const handleImageOpen = (img, idx = 0, imagesArray = []) => {
  //     setImageSelection(getImageUrl(img));
  //     setCurrentIndex(idx);
  //     setCurrentImages(imagesArray);
  //     setOpenImage(true);
  //   };

  const handleImageClose = () => {
    setImageSelection(null);
    setOpenImage(false);
    setZoom(1);
    setCurrentIndex(0);
    setCurrentImages([]);
  };

  const handleNext = () => {
    if (!currentImages || currentImages.length === 0) return;
    if (currentIndex < currentImages.length - 1) {
      const newIndex = currentIndex + 1;
      const nextUrl = getImageUrl(currentImages[newIndex]);
      if (nextUrl) {
        setCurrentIndex(newIndex);
        setImageSelection(nextUrl);
      }
    }
  };

  const handlePrev = () => {
    if (!currentImages || currentImages.length === 0) return;
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      const prevUrl = getImageUrl(currentImages[newIndex]);
      if (prevUrl) {
        setCurrentIndex(newIndex);
        setImageSelection(prevUrl);
      }
    }
  };

  const getFileType = (url) => {
    if (!url) return "";

    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (ext === "pdf") return "pdf";

    return "unknown";
  };
  return (
    <Modal
      keepMounted
      open={openImage}
      onClose={handleImageClose}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Box sx={imagestyle}>
        <div className="flex justify-between my-2">
          <a target="_blank" href={imageSelection} download={"image"}>
            <button class="cursor-pointer group relative flex gap-1.5 px-8 py-4 bg-black bg-opacity-80 text-[#f1f1f1] rounded-3xl hover:bg-opacity-70 transition font-semibold shadow-md">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                height="24px"
                width="24px"
              >
                <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                <g
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  id="SVGRepo_tracerCarrier"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <g id="Interface / Download">
                    {" "}
                    <path
                      stroke-linejoin="round"
                      stroke-linecap="round"
                      stroke-width="2"
                      stroke="#f1f1f1"
                      d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12"
                      id="Vector"
                    ></path>{" "}
                  </g>{" "}
                </g>
              </svg>
              Download
            </button>
          </a>
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex justify-center gap-4 z-[9999]">
            <button
              onClick={handleZoomIn}
              className="px-4 py-2 bg-black text-white rounded-lg hover:bg-opacity-80"
            >
              Zoom +
            </button>

            <button
              onClick={handleZoomOut}
              className="px-4 py-2 bg-black text-white rounded-lg hover:bg-opacity-80"
            >
              Zoom -
            </button>
          </div>

          <button
            onClick={handleImageClose}
            className="ml-3 text-white bg-red-500 hover:bg-red-600 p-2 rounded-full w-10 h-10 flex items-center justify-center transition"
          >
            ✕
          </button>
        </div>
        <div className="relative flex justify-center mt-4">
          <button
            onClick={handlePrev}
            disabled={currentIndex === 0}
            className="absolute left-2 top-1/2 -translate-y-1/2 
                                             text-black p-3 rounded-full bg-white/80 
                                             hover:bg-blue-200 disabled:opacity-40 
                                             w-12 h-12 flex items-center justify-center shadow"
          >
            <KeyboardArrowLeftIcon className="w-6 h-6" />
          </button>
          {imageSelection &&
            (() => {
              const type = getFileType(imageSelection);

              if (type === "image") {
                return (
                  <LazyLoadImage
                    src={imageSelection}
                    alt="attachment"
                    effect="blur"
                    placeholderSrc={imageSelection}
                    className="max-h-[70vh] object-contain transition-transform duration-200"
                    style={{ transform: `scale(${zoom})` }}
                  />
                );
              }

              if (type === "video") {
                return (
                  <video
                    src={imageSelection}
                    controls
                    className="max-h-[70vh] w-full object-contain"
                  />
                );
              }

              if (type === "pdf") {
                return (
                  <iframe
                    src={imageSelection}
                    title="PDF Viewer"
                    className="w-full h-[70vh]"
                  />
                );
              }

              return <p>Unsupported file type</p>;
            })()}

          <button
            onClick={handleNext}
            disabled={currentIndex === currentImages.length - 1}
            className="absolute right-2 top-1/2 -translate-y-1/2 
                                             text-black p-3 rounded-full bg-white/80 
                                             hover:bg-blue-200 disabled:opacity-40 
                                             w-12 h-12 flex items-center justify-center shadow"
          >
            <KeyboardArrowRightIcon className="w-6 h-6" />
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ImagePreviewLoop;
